export default [
  {
    path: '/revisao-conta',
    name: 'revisao-conta',
    component: () => import('./index')
  }
]
